import React, { useState, useEffect } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import queryString from 'query-string'
import Box from '@mui/material/Box'
import { FormattedMessage } from 'react-intl'
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded'

import { isValidUrl } from 'helpers/generalHelpers'
import RawHtml from 'stories/components/RawHtml'

const VideoInput = ({
  touched,
  error,
  SideElement,
  description,
  label,
  video_link: link,
  ...props
}) => {
  const [convertedLink, setConvertedLink] = useState('')

  const convertLink = (rawLink) => {
    if (!rawLink || error || !isValidUrl(rawLink)) {
      setConvertedLink('')
      return
    }
    const YoutubeDomains = [
      'www.youtube.com',
      'youtube.com',
      'www.youtube.be',
      'youtu.be',
    ]
    const AparatDomains = ['www.aparat.com', 'aparat.com']
    const VimeoDomains = ['www.vimeo.com', 'vimeo.com']
    let url = new URL(rawLink)
    if (YoutubeDomains.includes(url.hostname)) {
      /*
      url : https://www.youtube.com/watch?v=videoId
      */
      const videoId = queryString.parse(url.search).v
      setConvertedLink(
        `https://www.youtube.com/embed/${videoId}?feature=oembed`
      )
      return
    }
    if (AparatDomains.includes(url.hostname)) {
      /*
      url : https://www.aparat.com/v/videoId/
      pathname: /v/videoId/
      */
      const videoId = url.pathname.split('/')[2]
      setConvertedLink(
        `https://www.aparat.com/video/video/embed/videohash/${videoId}/vt/frame`
      )
    }
    if (VimeoDomains.includes(url.hostname)) {
      /*
      url : https://player.vimeo.com/video${videoId}
      */
      const videoId = url.pathname
      setConvertedLink(`https://player.vimeo.com/video${videoId}`)
    }
  }
  useEffect(() => {
    convertLink(link)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [link, error])

  const classNames = {
    'formz-text-input': true,
    'formz-has-error': props.error,
    'full-width': props.fullWidth,
  }
  return (
    <FieldRowWrapper
      className={classNames}
      error={error}
      touched={touched ? touched.toString() : undefined}
    >
      <label className="formz-field-and-label-holder">
        <div className="formz-section-input">
          <h3>{label}</h3>
          {convertedLink ? (
            <iframe
              className="formz-video-iframe-input"
              src={convertedLink}
              title={label}
              height={400}
              width="100%"
            />
          ) : (
            <Box
              my={1}
              align="center"
              display="flex"
              alignItems="center"
              justifyContent="center"
              className="formz-video-input-placeholder"
            >
              <PlayCircleOutlineRoundedIcon />
              <Box mx={0.5}>
                <FormattedMessage id="pages.formMaker.section.editFieldSettings.fields.videoLink.placeholder" />
              </Box>
            </Box>
          )}
          <RawHtml content={description} />
        </div>

        {SideElement && <SideElement />}
      </label>
    </FieldRowWrapper>
  )
}

export default class VideoInputWrapper extends React.Component {
  render() {
    return <VideoInput {...this.props} />
  }
}
